import React, { useState } from 'react';
import {
  Container,
  HeaderWrapper,
  MainWrapper,
} from 'lib/components/styles/layout';
import { Heading } from 'lib/components/styles/typography';
import { Tabs } from 'lib/components';
import { Tab } from 'lib/components/tabs';
import { useQueryCustomerAvatars } from 'lib/api/avatars/customerAvatars/useQueryCustomerAvatars';
import { AIAssistantsList } from '../components/AIAssistantsList';
import { Content } from '../components/styles';
import { BackgroundList } from '../backgrounds/BackgroundList';
import { Button } from 'react-covideo-common';
import { MdAdd } from 'react-icons/md';
import { useTheme } from 'styled-components/macro';
import { useQueryBackgrounds } from 'lib/api/backgrounds/useQueryBackgrounds';
import { AddBackgroundModal } from '../backgrounds/modals/AddBackgroundModal';
import { useDefaultBackgroundMutation } from 'lib/api/backgrounds/useDefaultBackgroundMutation';
import { useTranslation } from 'react-i18next';

export const Main = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const [activeTab, setActiveTab] = useState(0);
  const [showBackgroundUploadModal, setShowBackgroundUploadModal] =
    useState(false);
  const { data: aiAssistants, isLoading: isLoadingAIAssistants } =
    useQueryCustomerAvatars();
  const { data: backgrounds, isLoading: isLoadingBackgrounds } =
    useQueryBackgrounds();

  const { mutateAsync: setDefaultBackgroundMutation } =
    useDefaultBackgroundMutation();

  const onDefaultBackgroundChange = (backgroundId: number) => {
    setDefaultBackgroundMutation({ id: backgroundId });
  };

  const tabs: Tab[] = [
    {
      title: t('Agents'),
      inActiveTextColor: theme.colors.neutral[60],
      component:
        activeTab == 0 ? (
          <AIAssistantsList
            aiAssistants={aiAssistants || []}
            isLoading={isLoadingAIAssistants}
          />
        ) : null,
    },
    {
      title: t('Backgrounds'),
      inActiveTextColor: theme.colors.neutral[60],
      component:
        activeTab == 1 ? (
          <BackgroundList
            backgrounds={backgrounds || []}
            isLoading={isLoadingBackgrounds}
            onDefaultBackgroundChange={onDefaultBackgroundChange}
            selectedText={t('Default Background')}
            unselectedText={t('Set As Default Background')}
          />
        ) : null,
    },
  ];

  const toggleShowBackgroundUploadModal = () => {
    setShowBackgroundUploadModal(prev => !prev);
  };

  return (
    <Container>
      <MainWrapper resetPadding={false}>
        <HeaderWrapper m='0 0 26px 16px'>
          <Heading>{t('AI Video Agents')}</Heading>
          {activeTab === 1 && (
            <Button
              text={t('Add Background')}
              icon={<MdAdd color={theme.colors.white[100]} />}
              onClick={toggleShowBackgroundUploadModal}
            />
          )}
          <AddBackgroundModal
            isOpen={showBackgroundUploadModal}
            onClose={toggleShowBackgroundUploadModal}
          />
        </HeaderWrapper>
        <Content>
          <Tabs
            tabs={tabs}
            defaultActiveTab={activeTab}
            onChange={setActiveTab}
            navbarPadding='16px 0px 0px 0px'
          />
        </Content>
      </MainWrapper>
    </Container>
  );
};
